/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { useIntl } from 'react-intl'
import { PageTitle } from '../../../_metronic/layout/core'
// import {
//   ListsWidget26,
//   TablesWidget14,
// } from '../../../_metronic/partials/widgets'
// import { ListsWidget10 } from '../../../_metronic/partials/widgets/lists/ListsWidget10'
// import { ListsWidget11 } from '../../../_metronic/partials/widgets/lists/ListsWidget11'
// import { ListsWidget12 } from '../../../_metronic/partials/widgets/lists/ListsWidget12'
// import { CardsWidget1 } from '../../../_metronic/partials/widgets/_new/cards/CardsWidget1'
// import MapView from '../../../_metronic/partials/widgets/_new/maps/MapView'
import { LogsListWrapper } from '../../modules/apps/logs-management/users-list/LogsList'


const DashboardPage: FC = () => (
  <>
    {/*Datos*/}
    {/* <div className='row gy-5 g-xl-8'>
      <div className='col-xl-4'>
        <ListsWidget10 className='card-xl-stretch mb-xl-8' />
      </div>
      <div className='col-xl-4'>
        <ListsWidget11 className='card-xl-stretch mb-xl-8' />
      </div>
      <div className='col-xl-4'>
        <ListsWidget12 className='card-xl-stretch mb-xl-8' />
        
      </div>
    </div> */}
    {/*Grafico de Ventas*/}
    {/* <div className='row g-5 g-xl-8'>
      <div className='col-xl-4'>
        <MixedWidget16 className='card-xl-stretch mb-xl-8' chartColor='info' chartHeight='200px' />
      </div>

      <div className='col-xl-4'>
        <MixedWidget17 className='card-xl-stretch mb-xl-8' chartColor='warning' chartHeight='200px' />
      </div>

      <div className='col-xl-4'>
        <MixedWidget18 className='card-xl-stretch mb-xl-8' chartColor='primary' chartHeight='200px' />
      </div>
    </div> */}
    {/*Otros datos*/}
    <div className='d-flex flex-row justify-content-between col-12'>
      <LogsListWrapper />
      {/* <div className='d-flex flex-column col-6'>
        <div className='mb-5 mb-xl-10 me-5 me-xl-10'>
          <LogsListWrapper />
        </div>
        <div className='d-flex flex-row justify-content-between col-12'>
          <div className='col-6'>
            <TablesWidget14 className='mb-5 mb-xl-10' />
          </div>
          <div className='col-6'>
            <CardsWidget1 className='mb-5 mb-xl-10 mx-5 mx-xl-10' />
            <ListsWidget26 className='mb-5 mb-xl-10 mx-5 mx-xl-10' />
          </div>
        </div>
      </div>
      <div className='col-6'>
        <MapView></MapView>
      </div> */}
    </div>
  </>
)

const DashboardWrapper: FC = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'MENU.DASHBOARD' })}</PageTitle>
      <DashboardPage />
    </>
  )
}

export { DashboardWrapper }
